import {
  enumListAsRecordObject,
  lookupListAsRecordObject
} from '@utils/graph-utils';

/**
 * =========================================
 * CLAIM PERSON LOV MAPPER
 * (No Business Details dependency needed)
 * =========================================
 */
export function LookupToList(data: any) {
  const personEnums: Record<string, Record<string, string>> = {};

  /**
   * =========================
   * ENUMS
   * =========================
   */

  personEnums['PolicyPersonTypeList'] = enumListAsRecordObject(
    data?.PolicyPersonTypeList?.enumValues
  );

  personEnums['PersonTypes'] = enumListAsRecordObject(
    data?.PersonType?.enumValues
  );

  personEnums['phoneType'] = enumListAsRecordObject(
    data?.PhoneType?.enumValues
  );

  personEnums['genders'] = enumListAsRecordObject(data?.Gender?.enumValues);

  personEnums['addressType'] = enumListAsRecordObject(
    data?.PersonAddressType?.enumValues
  );

  /**
   * =========================
   * LOOKUPS (CORE DATA)
   * =========================
   */

  personEnums['zones'] = lookupListAsRecordObject(data?.core?.getZones ?? []);

  personEnums['titles'] = lookupListAsRecordObject(data?.core?.getTitles ?? []);

  personEnums['nationalities'] = lookupListAsRecordObject(
    data?.core?.getNationalities ?? [],
    false,
    'id',
    'title',
    'code',
    true
  );

  personEnums['countries'] = lookupListAsRecordObject(
    data?.core?.getCountries ?? []
  );

  /**
   * =========================
   * CLAIM-SAFE OUTPUT
   * =========================
   * (Intentionally not enforcing business-related LOVs)
   */

  return personEnums;
}
